var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { AuthProviders, FirebaseAuth, AuthMethods } from 'angularfire2';
import { Facebook } from 'ionic-native';
import { Platform } from 'ionic-angular';
export var AuthService = (function () {
    function AuthService(auth$, platform) {
        var _this = this;
        this.auth$ = auth$;
        this.platform = platform;
        auth$.subscribe(function (state) {
            _this.authState = state;
        });
    }
    Object.defineProperty(AuthService.prototype, "authenticated", {
        get: function () {
            return this.authState !== null && !this.expired;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "expired", {
        get: function () {
            return !this.authState || (this.authState.expires * 1000) < Date.now();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "id", {
        get: function () {
            return this.authenticated ? this.authState.uid : '';
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.subscribe = function (observerOrNext, error, complete) {
        return this.auth$.subscribe(observerOrNext);
    };
    AuthService.prototype.signIn = function () {
        var _this = this;
        if (this.platform.is('cordova')) {
            var facebookConfig = {
                method: AuthMethods.OAuthToken,
                provider: AuthProviders.Facebook
            };
            Facebook.login(['email']).then(function (_response) {
                var creds = firebase.auth.FacebookAuthProvider.credential(_response.authResponse.accessToken);
                return _this.auth$.login(creds, facebookConfig);
            });
        }
        else {
            this.auth$.login();
        }
    };
    AuthService.prototype.signOut = function () {
        this.auth$.logout();
    };
    AuthService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [FirebaseAuth, Platform])
    ], AuthService);
    return AuthService;
}());
